import { render } from "./edit-assets.vue?vue&type=template&id=46efb4ec"
import script from "./edit-assets.vue?vue&type=script&lang=js"
export * from "./edit-assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__